import Vue from 'vue';

Vue.component('report-fuel-sales-by-tank-index', () =>
    import(/* webpackChunkName: 'report-fuel-sales-by-tank-index' */ './report-fuel-sales-by-tank-index.vue'),
);
